export var CF_BOT_SCORE_PROPERTY = 'cf_bot_score';
export var BOT_SCORE_HUMAN_THRESHOLD = 30;
var parseBotScore = function (botScore) {
    if (botScore === undefined)
        return undefined;
    var parsed = Number(botScore);
    return Number.isFinite(parsed) ? parsed : undefined;
};
export var buildExperimentUserProperties = function (botScore) {
    var _a;
    var parsed = parseBotScore(botScore);
    if (parsed === undefined)
        return undefined;
    return {
        user_properties: (_a = {},
            _a[CF_BOT_SCORE_PROPERTY] = parsed,
            _a),
    };
};
export var isLikelyBot = function (botScore) {
    var parsed = parseBotScore(botScore);
    return parsed !== undefined && parsed <= BOT_SCORE_HUMAN_THRESHOLD;
};
